import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import DateTime from "../../../../components/Formatters/DateTime";
import TextSpinner from "../../../../components/UI/Spinner/TextSpinner";
import useDetalhamento from "../hooks/useDetalhamento";
import FormDemonstrativos from "../FormDemonstrativos";
import useMontarLogica from "../hooks/useMontarLogica";
import constants from "../../../Constants";

const columns = [
  {
    name: "Descrição",
    selector: (row) => row.nuItem,
  },
  {
    name: "N° Série",
    selector: (row) => row.txReferencia,
  },
  {
    name: "Data de Vencimento",
    selector: (row) => row.dtVencimento,
    minWidth: "15%",
    cell: (row) => <DateTime value={row.dtVencimento} stringFormat="dd/MM/yyyy" />,
  },
  {
    name: "ICMS",
    selector: (row) => row.vlIcms,
  },
  {
    name: "Multa",
    selector: (row) => row.vlMultaOcorrenciaAtual,
  },
];

const conditionalRowStyles = [
  {
    when: (row) => row.dsItem === "Total",
    style: { backgroundColor: "#d3d3d3", cursor: "not-allowed" },
  },
];

const ListagemE = ({ history, sqItemOcorrencia, sqAcaoFiscal }) => {
  const [reload, setReload] = useState(false);
  const { dataWithTotal, totalRows, isLoading } = useDetalhamento({
    sqAcaoFiscal,
    sqItemOcorrencia,
    reload,
  });

  const [dados, setDados] = useState({});

  const { montarLogica, mostrarLista, setMostrarLista } = useMontarLogica();

  useEffect(() => {
    if (mostrarLista) {
      montarLogica(1);
    }
  }, [montarLogica, mostrarLista, reload]);

  const voltarListagem = () => {
    setMostrarLista(true);
    setReload((prev) => prev + 1);
  };

  return mostrarLista ? (
    <DataTable
      noHeader
      keyField="sqItemOcorrencia"
      columns={columns}
      data={dataWithTotal}
      progressPending={isLoading}
      noDataComponent="Nenhum registro para exibir"
      progressComponent={<TextSpinner />}
      paginationTotalRows={totalRows}
      pointerOnHover
      pagination
      paginationComponentOptions={constants.paginationComponentOptions}
      onRowClicked={(row) => {
        if (row.nuItem !== "Total") {
          setDados(row);
          montarLogica(4);
        }
      }}
      conditionalRowStyles={conditionalRowStyles}
      paginationPerPage={10}
    />
  ) : (
    <FormDemonstrativos
      tipoDetalhamento={dados.tipoDetalhamento}
      sqItemOcorrencia={dados.sqItemOcorrencia}
      sqAcaoFiscal={dados.sqAcaoFiscal}
      dadosOcorrencia={dados}
      history={history}
      voltarListagem={() => voltarListagem()}
    />
  );
};

export default ListagemE;
